import { isDefined, isNotDefined } from '@sgme/fp';
import { useCallback } from 'react';
import { useIntl } from 'react-intl';

import { useCurrentUserQuery } from '@/api/user/index.ts';
import { useTrackEvent } from '@/App/Blotter/useTrackEvent.ts';
import { blotterApi } from '@/store/blotter/api/index.ts';

interface BlotterEntry {
  id: string;
}

type Props = {
  entry: BlotterEntry;
  entryType: 'cash' | 'option' | 'accumulator';
};

export const OpenInXoneButton = ({ entry: { id }, entryType }: Props) => {
  const { formatMessage } = useIntl();

  const track = useTrackEvent();

  const { data: { userType } = {} } = useCurrentUserQuery();

  const [openInXone] = blotterApi.useLazyOpenInXoneQuery();

  const reasonForDisabling =
    isNotDefined(userType) || userType === 'Trader'
      ? formatMessage({ id: 'blotter.column.actions.openInXone.disablingReason' })
      : undefined;

  const tooltip = reasonForDisabling ?? formatMessage({ id: 'blotter.column.actions.openInXone' });

  const handleClick = useCallback(() => {
    openInXone({ reference: id });
    track(`Open ${entryType} in Xone`, id);
  }, [id, entryType, openInXone]);

  return (
    <span title={tooltip}>
      <button
        type="button"
        className="btn btn-link btn-icon p-0 me-2"
        onClick={handleClick}
        disabled={isDefined(reasonForDisabling)}
      >
        <i className="icon icon-sm">launch</i>
      </button>
    </span>
  );
};
